<template>
    <div class="container-fluid">
        <div class="page-heading mb-4">
            <p class="page-eyebrow">QUIZ MANAGEMENT</p>
            <h1 class="h3 mb-1 text-gray-800">Quiz questions</h1>
            <p class="mb-0 text-muted">Create and manage questions for delegate quizzes.</p>
        </div>

        <QuestionList></QuestionList>
    </div>

</template>

<script>
import {defineComponent} from 'vue'
import QuestionList from "@/components/quiz/QuestionList.vue";

export default defineComponent({
    name: "QuestionPage",
    components: {
        QuestionList
    }
})
</script>


<style scoped>
.page-heading{border-bottom:1px solid #e2e6ea;padding-bottom:1rem}.page-eyebrow{color:#426cc6;font-size:.72rem;font-weight:700;letter-spacing:.08em;margin:0 0 .35rem}
</style>
